/* TWRD size finder, the guided size pop-up on the product page.
   Markup and data: snippets/twrd-size-finder.liquid. Styles: twrd-size-finder.css.

   It opens from the box at the bottom of the Size Guide drawer. The drawer
   closes first, so there is never a third layer. "See the full table" goes
   back to the drawer.

   The result drives the theme's own variant picker, and "Add to bag" clicks
   the theme's own add button. No cart request is built here, so the cart
   store updates and the cart drawer opens as usual.

   KEEP EQUAL: RULE.order and RULE.ladder below must stay equal to SIZE_RULE in
   assets/twrd-chat-widget.js. The chat and this pop-up must give the same
   size for the same body. backend/tests/size-finder-ladder.test.ts compares
   the numbers in both files and fails when they drift. */
(function () {
  'use strict';

  if (window.__twrdSizeFinderInit) return;
  window.__twrdSizeFinderInit = true;

  /* ================= Data ================= */
  var RULE = Object.freeze({
    order: ['S', 'M', 'L', 'XL', '2XL'],
    // Read top down, first match wins. Above the last step: 2XL.
    ladder: [
      { height: 170, weight: 65, size: 'S' },
      { height: 178, weight: 75, size: 'M' },
      { height: 190, weight: 92, size: 'L' },
      { height: 198, weight: 105, size: 'XL' },
    ],
    builds: ['slim', 'average', 'broad'],
    fits: ['regular', 'up']
  });
  var RULER = Object.freeze({
    us: { h: { min: 59, max: 81, ppu: 24, major: 12, mid: 3, label: 3 }, w: { min: 100, max: 285, ppu: 6, major: 10, mid: 5, label: 10 } },
    metric: { h: { min: 150, max: 205, ppu: 10, major: 10, mid: 5, label: 5 }, w: { min: 45, max: 130, ppu: 10, major: 10, mid: 5, label: 5 } }
  });
  var KIND_WORDS = Object.freeze({
    tee: { own: 'a tee you own', noun: 'tee' },
    tee_special: { own: 'a tee you own', noun: 'tee' },
    croptop: { own: 'a tee you own', noun: 'tee' },
    hoodie: { own: 'a hoodie you own', noun: 'hoodie' },
    sweatshirt: { own: 'a sweatshirt you own', noun: 'sweatshirt' },
    sweatpants: { own: 'sweatpants you own', noun: 'pair' }
  });
  var KEY = 'twrd_size_profile_v1';
  var IN = 2.54, LB = 0.45359237;
  var BUILD_WORD = { slim: 'Slim', average: 'Average', broad: 'Broad' };
  // Every piece is cut oversized. There is no close fit to offer.
  var FIT_WORD = { regular: 'As in the photos', up: 'Really big' };
  var ENTRY_TEXT = 'Help me find my size';

  function warn(msg, err) { if (window.console) console.warn('[twrd-size-finder] ' + msg, err || ''); }
  function all(sel, root) { return Array.prototype.slice.call((root || document).querySelectorAll(sel)); }
  function $(id) { return document.getElementById('twrd-sf-' + id); }

  /* ---- The product in front of the visitor. Never trust the payload. ---- */
  function readPiece() {
    var el = document.querySelector('[data-twrd-sf-data]');
    if (!el) return null;
    var raw;
    try { raw = JSON.parse(el.textContent || 'null'); } catch (err) { warn('invalid data', err); return null; }
    if (!raw || !Array.isArray(raw.sizes)) return null;
    var sizes = [], avail = {}, value = {};
    raw.sizes.forEach(function (s) {
      var label = String(s && s.v != null ? s.v : '').trim(), up = label.toUpperCase();
      if (RULE.order.indexOf(up) < 0 || sizes.indexOf(up) >= 0) return;
      sizes.push(up); avail[up] = !!s.a; value[up] = label;
    });
    // Ladder order, whatever order the product lists them in.
    sizes = RULE.order.filter(function (s) { return sizes.indexOf(s) >= 0; });
    if (!sizes.length) return null;
    var rows = {}, cols = [];
    var chart = raw.chart;
    if (chart && chart.rows && Array.isArray(chart.columns) && chart.columns.length >= 2) {
      var keys = [String(chart.columns[0]), String(chart.columns[1])];
      // The drawer labels sweatpants waist and hip as "Waist (around)". The finder uses the plain name.
      cols = keys.map(function (c) { return c.replace(/\s*\(around\)\s*$/i, ''); });
      Object.keys(chart.rows).forEach(function (k) {
        var r = chart.rows[k], a, b;
        if (Array.isArray(r)) { a = Number(r[0]); b = Number(r[1]); }
        else if (r && typeof r === 'object') { a = Number(r[keys[0]]); b = Number(r[keys[1]]); }
        if (isFinite(a) && isFinite(b)) rows[String(k).trim().toUpperCase()] = [a, b];
      });
    }
    // variant id -> size, to check what the product form will really add.
    var bySize = {};
    (Array.isArray(raw.variants) ? raw.variants : []).forEach(function (pair) {
      if (Array.isArray(pair)) bySize[String(pair[0])] = String(pair[1] == null ? '' : pair[1]).trim().toUpperCase();
    });
    var kind = KIND_WORDS[raw.kind] ? raw.kind : 'tee';
    return Object.freeze({ kind: kind, own: KIND_WORDS[kind].own, noun: KIND_WORDS[kind].noun, sizes: sizes, avail: avail, value: value,
      cols: cols, rows: rows, variantSize: bySize, us: String(raw.country || '').toUpperCase() === 'US',
      // The model line of this product, from snippets/twrd-model-line.liquid.
      model: typeof raw.model === 'string' ? raw.model.trim().slice(0, 200) : '',
      // TWRD 2026-10-29: UPCOMING piece (snippets/twrd-is-upcoming.liquid). Size advice only, never Add to bag.
      upcoming: raw.upcoming === true });
  }
  var PIECE = readPiece();
  if (!PIECE || !$('box')) return;

  /* ================= Pure logic ================= */
  function clamp(v, a, b) { return Math.min(b, Math.max(a, v)); }
  function ladderIndex(value, key) {
    for (var i = 0; i < RULE.ladder.length; i += 1) if (value <= RULE.ladder[i][key]) return i;
    return RULE.ladder.length;
  }
  // The first size sold at or above index i. -1 when there is none.
  function soldFrom(i, soldIdx) {
    for (var k = 0; k < soldIdx.length; k += 1) if (soldIdx[k] >= i) return soldIdx[k];
    return -1;
  }
  // { state:'noguess' } or { state:'ok', pick, alt, body, max, min, capped, floored, shifted, noUp }
  // `sold` is the list of sizes this product is sold in. A size outside it is never offered.
  function recommend(input, sold) {
    var order = RULE.order;
    var soldIdx = order.map(function (s, i) { return sold.indexOf(s) >= 0 ? i : -1; }).filter(function (i) { return i >= 0; });
    var max = soldIdx[soldIdx.length - 1], min = soldIdx[0];
    var hi = ladderIndex(input.cm, 'height'), wi = ladderIndex(input.kg, 'weight');
    var lo = Math.min(hi, wi), up = Math.max(hi, wi);
    if (up - lo >= 2) return { state: 'noguess' };
    var body, alt = -1;
    if (up === lo) { body = lo; if (input.build === 'broad') alt = lo + 1; }
    else if (input.build === 'slim') body = lo;
    else if (input.build === 'broad') body = up;
    else { body = lo; alt = up; }
    var capped = body > max, floored = body < min;
    var base = capped ? max : soldFrom(body, soldIdx), pick = base, shifted = false, noUp = false;
    if (input.fit === 'up') {
      var next = soldFrom(base + 1, soldIdx);
      if (next >= 0) { pick = next; shifted = true; } else { noUp = true; }
    }
    if (shifted) alt = base;
    else if (alt === pick || capped || floored || soldIdx.indexOf(alt) < 0) alt = -1;
    return { state: 'ok', pick: order[pick], alt: alt >= 0 ? order[alt] : null, body: order[body], max: order[max], min: order[min],
      capped: capped, floored: floored, shifted: shifted, noUp: noUp };
  }
  // Closest size by flat measurements. a and b are cm. Returns { best, rows:[{size, m:[..], d:[..]}] } or null.
  function compareOwn(a, b) {
    if (!(a >= 20 && a <= 140 && b >= 20 && b <= 140)) return null;
    var best = null, bestD = Infinity, rows = [];
    PIECE.sizes.forEach(function (s) {
      var m = PIECE.rows[s]; if (!m) return;
      var d = [m[0] - a, m[1] - b], dist = Math.abs(d[0]) + Math.abs(d[1]);
      if (dist < bestD) { bestD = dist; best = s; }
      rows.push({ size: s, m: m, d: d });
    });
    return best ? { best: best, rows: rows } : null;
  }
  function parseNum(text) {
    var n = Number(String(text).trim().replace(',', '.'));
    return text !== '' && isFinite(n) ? n : NaN;
  }

  /* ================= Formatting ================= */
  function fmtH(unit, v) {
    if (unit === 'metric') return { short: v + ' cm', say: v + ' centimeters' };
    var ft = Math.floor(v / 12), inch = v % 12;
    return { short: ft + "'" + inch, say: ft + ' feet ' + inch + ' inches' };
  }
  function fmtW(unit, v) { return unit === 'metric' ? { short: v + ' kg', say: v + ' kilograms' } : { short: v + ' lb', say: v + ' pounds' }; }
  function len(unit, cm) { return unit === 'metric' ? String(Math.round(cm * 10) / 10) : (Math.round(cm / IN * 10) / 10).toFixed(1); }
  function lenU(unit) { return unit === 'metric' ? 'cm' : 'in'; }
  function signed(unit, cm) {
    var v = unit === 'metric' ? Math.round(cm * 10) / 10 : Math.round(cm / IN * 10) / 10;
    return v === 0 ? '0' : (v > 0 ? '+' : '\u2212') + Math.abs(v);
  }
  // One parametric torso with arms. sw = half shoulder width, ww = half waist, hw = half hip.
  var BUILD_FIG = Object.freeze({ slim: { sw: 23, ww: 14, hw: 15 }, average: { sw: 29, ww: 19, hw: 19 }, broad: { sw: 36, ww: 26, hw: 24 } });
  function torso(b) {
    var C = 60, s = b.sw, w = b.ww, h = b.hw, arm = Math.round(7 + s * 0.12);
    return 'M' + (C - 6) + ' 37 L' + (C - 7) + ' 45' +
      ' Q' + (C - s * 0.55) + ' 48 ' + (C - s) + ' 55' +
      ' Q' + (C - s - 5) + ' 60 ' + (C - s - 4) + ' 72 L' + (C - s - 3) + ' 100' +
      ' L' + (C - s - 3 + arm) + ' 100 L' + (C - s + arm - 1) + ' 75' +
      ' Q' + (C - w - 1) + ' 96 ' + (C - w) + ' 114 Q' + (C - w) + ' 131 ' + (C - h) + ' 148' +
      ' L' + (C + h) + ' 148 Q' + (C + w) + ' 131 ' + (C + w) + ' 114' +
      ' Q' + (C + w + 1) + ' 96 ' + (C + s - arm + 1) + ' 75 L' + (C + s + 3 - arm) + ' 100' +
      ' L' + (C + s + 3) + ' 100 L' + (C + s + 4) + ' 72' +
      ' Q' + (C + s + 5) + ' 60 ' + (C + s) + ' 55 Q' + (C + s * 0.55) + ' 48 ' + (C + 7) + ' 45' +
      ' L' + (C + 6) + ' 37 Z';
  }
  // Soft fill, outline, and a shoulder measure line with end ticks above the head.
  function buildFigure(b) {
    var shape = '<ellipse cx="60" cy="23" rx="10.5" ry="12.5"/><path d="' + torso(b) + '"/>';
    var x1 = 60 - b.sw - 4, x2 = 60 + b.sw + 4;
    return '<g class="twrd-sf__soft">' + shape + '</g><g class="twrd-sf__line">' + shape + '</g>' +
      '<line class="twrd-sf__tick" x1="' + x1 + '" y1="8" x2="' + x2 + '" y2="8"/>' +
      '<line class="twrd-sf__tick" x1="' + x1 + '" y1="4" x2="' + x1 + '" y2="12"/>' +
      '<line class="twrd-sf__tick" x1="' + x2 + '" y1="4" x2="' + x2 + '" y2="12"/>';
  }

  /* ================= Storage (never trust what comes back) ================= */
  function readProfile() {
    try {
      var p = JSON.parse(window.localStorage.getItem(KEY) || 'null');
      if (!p || !isFinite(p.heightCm) || !isFinite(p.weightKg)) return null;
      // build is null when the profile was made on sweatpants, where build is not asked.
      if ((p.build !== null && RULE.builds.indexOf(p.build) < 0) || RULE.fits.indexOf(p.fit) < 0 || !p.sizes || typeof p.sizes !== 'object') return null;
      return p;
    } catch (err) { warn('saved profile unreadable', err); return null; }
  }
  function writeProfile(p) {
    try { window.localStorage.setItem(KEY, JSON.stringify(p)); return true; }
    catch (err) { warn('could not save', err); return false; }
  }
  /* HOOK, NOT BUILT. The profile is saved on this device only. Saving it to
     the customer's account needs a backend write that does not exist yet:
     a customer metafield written through an app proxy, or through the chat
     backend with a customer-signed token. Until one of them exists this does
     nothing, and the pop-up never says "saved to your account". */
  function persistRemote(profile) { void profile; }

  /* ================= State. Every change makes a new object. ================= */
  var FRESH = Object.freeze({ unit: PIECE.us ? 'us' : 'metric', h: PIECE.us ? 70 : 178, w: PIECE.us ? 175 : 78, build: null, fit: null,
    active: 0, reached: 0, compact: false, cmpOpen: false, cmpA: '', cmpB: '', override: null, savedMsg: '' });
  // The questions, by their data-q index: 0 height, 1 weight, 2 build, 3 fit.
  // Sweatpants skip build: between two sizes the fit wish decides. "As in the
  // photos" takes the smaller, "Really big" takes the larger. That is the
  // same as an average build in recommend(), so no second rule is needed.
  var PANTS = PIECE.kind === 'sweatpants';
  var ORDER = PANTS ? [0, 1, 3] : [0, 1, 2, 3];
  var N = ORDER.length;
  var page = Object.freeze({ profile: readProfile() });
  var pop = FRESH;
  var isOpen = false, builtUnit = null, dragging = null, returnTo = null, prevOverflow = '', adding = false;
  var root = document.getElementById('twrd-sf');

  function setPop(patch) {
    var next = Object.assign({}, pop, patch);
    // Any change to an answer clears the own-piece override and the saved line.
    ['unit', 'h', 'w', 'build', 'fit'].forEach(function (k) {
      if (k in patch && patch[k] !== pop[k]) { next.override = 'override' in patch ? patch.override : null; next.savedMsg = 'savedMsg' in patch ? patch.savedMsg : ''; }
    });
    pop = Object.freeze(next);
    renderPop();
  }
  function metric(s) { return s.unit === 'metric' ? { cm: s.h, kg: s.w } : { cm: s.h * IN, kg: s.w * LB }; }
  function recNow() {
    var m = metric(pop);
    return recommend({ cm: m.cm, kg: m.kg, build: PANTS ? 'average' : (pop.build || 'average'), fit: pop.fit || 'regular' }, PIECE.sizes);
  }
  function soldSize(size) { return PIECE.sizes.indexOf(size) >= 0 ? size : null; }

  // The saved size for THIS product. The size saved for this kind of piece
  // wins. Without one, the saved body is read against the sizes sold here.
  function savedSize() {
    var p = page.profile;
    if (!p) return null;
    var own = soldSize(p.sizes[PIECE.kind]);
    if (own) return own;
    var r = recommend({ cm: p.heightCm, kg: p.weightKg, build: PANTS ? 'average' : (p.build || 'average'), fit: p.fit }, PIECE.sizes);
    return r.state === 'ok' && !r.capped && !r.floored ? r.pick : null;
  }

  // Everything the result block shows, from state.
  function view() {
    var rec = recNow();
    var lead = 'At ' + fmtH(pop.unit, pop.h).short + ' and ' + fmtW(pop.unit, pop.w).short + (PANTS ? ': ' : ', ' + (pop.build || 'average') + ' build: ');
    var over = soldSize(pop.override);
    var v = { rec: rec, pick: null, alt: null, letter: '', sentence: '', altText: '', bodyPick: rec.state === 'ok' ? rec.pick : null, out: false };
    if (over && over !== v.bodyPick) {
      v.pick = over; v.alt = v.bodyPick; v.letter = over;
      v.sentence = 'By the ' + PIECE.noun + ' you own: take ' + over + '.';
      v.altText = v.bodyPick ? 'Your body reads ' + v.bodyPick + '.' : 'Your height and weight point to sizes far apart.';
    } else if (rec.state === 'noguess') {
      v.letter = '?';
      v.sentence = 'Your height and weight point to sizes far apart.';
      v.altText = 'Measure ' + PIECE.own + ' and compare it with the table.';
      return v;
    } else {
      v.pick = rec.pick; v.alt = rec.alt; v.letter = rec.pick;
      v.sentence = lead + 'take ' + rec.pick + '.';
      if (rec.capped) { v.sentence = lead + 'this piece stops at ' + rec.max + '.'; v.altText = rec.max + ' is the largest size. Compare it with ' + PIECE.own + '.'; }
      else if (rec.floored) { v.sentence = lead + 'this piece starts at ' + rec.min + '.'; v.altText = rec.min + ' is the smallest size. Compare it with ' + PIECE.own + '.'; }
      else if (rec.noUp) v.altText = 'This piece stops at ' + rec.max + '. There is no size above it.';
      else if (rec.shifted) v.altText = rec.alt + ' is the fit in the photos. ' + rec.pick + ' is bigger and longer.';
      else if (rec.alt) v.altText = rec.pick + ' is the fit in the photos. ' + rec.alt + ' is bigger and longer.';
      else v.altText = 'This is the fit in the photos. The cut is already oversized.';
    }
    if (!PIECE.avail[v.pick]) {
      v.out = true;
      v.altText += ' ' + v.pick + ' is sold out right now.' + (v.alt && PIECE.avail[v.alt] ? ' ' + v.alt + ' is in stock.' : '');
    }
    return v;
  }

  /* ================= The product page: variant picker and add button =================
     Same approach as snippets/twrd-sticky-atc.liquid. We click the theme's own
     size input and the theme's own add button, so the theme's variant logic,
     price, availability and cart drawer run exactly as on a normal click. */
  function productForm() {
    return document.querySelector('product-form form[action*="/cart/add"]') || document.querySelector('form[action*="/cart/add"]');
  }
  // Venue keeps the radios outside <form> and binds them with the form attribute.
  function formRadios(form) {
    var list = [];
    if (form && form.elements) Array.prototype.forEach.call(form.elements, function (el) { if (el && el.type === 'radio') list.push(el); });
    if (!list.length) list = all('input[type="radio"]', document.querySelector('.product-single') || document);
    return list;
  }
  function isSizeName(name) {
    var plain = String(name || '').toLowerCase().replace(/^options?\[|\]$/g, '').trim();
    return plain === 'size' || plain === 'st\u00f8rrelse' || plain === 'storrelse';
  }
  function sizeRadios() { return formRadios(productForm()).filter(function (r) { return isSizeName(r.name); }); }
  var selfPick = false;
  function selectSizeOnPdp(size) {
    var want = String(PIECE.value[size] || size).toLowerCase();
    var radios = sizeRadios();
    for (var i = 0; i < radios.length; i += 1) {
      if (String(radios[i].value || '').toLowerCase() !== want) continue;
      if (radios[i].checked) {
        // Checked, but the form holds another variant: the theme missed the
        // change (its request failed). Tell it again.
        if (!formHasSize(size)) {
          selfPick = true;
          try { radios[i].dispatchEvent(new Event('change', { bubbles: true })); } finally { selfPick = false; }
        }
        return true;
      }
      // The input is visually hidden. Click its label so the theme's own handlers run.
      var lbl = radios[i].id ? document.querySelector('label[for="' + radios[i].id + '"]') : null;
      // The change event that follows is fired by the browser, so it looks
      // like a hand pick. The flag tells our own listener it was us.
      selfPick = true;
      try { if (lbl) lbl.click(); else radios[i].click(); } finally { selfPick = false; }
      return true;
    }
    // Fallback: the theme can use a <select> instead of radio buttons.
    var form = productForm(), selects = [];
    if (form && form.elements) Array.prototype.forEach.call(form.elements, function (el) { if (el && el.tagName === 'SELECT' && isSizeName(el.name)) selects.push(el); });
    for (var s = 0; s < selects.length; s += 1) {
      for (var o = 0; o < selects[s].options.length; o += 1) {
        if (String(selects[s].options[o].value || '').toLowerCase() !== want) continue;
        selects[s].selectedIndex = o;
        selfPick = true;
        try { selects[s].dispatchEvent(new Event('change', { bubbles: true })); } finally { selfPick = false; }
        return true;
      }
    }
    return false;
  }
  function primaryAddButton() {
    return document.querySelector('product-form button[name="add"]')
      || document.querySelector('product-form .c-btn--primary[type="submit"]')
      || document.querySelector('.product-form__buttons button[name="add"]')
      || document.querySelector('form[action*="/cart/add"] button[type="submit"]');
  }
  function variantId() {
    var form = productForm(), input = form ? form.querySelector('input[name="id"]') : null;
    return input ? String(input.value) : '';
  }

  function formHasSize(size) { return PIECE.variantSize[variantId()] === size; }
  // Select a size and wait until the theme's product form really holds a
  // variant in that size. The theme fetches the new variant over the network.
  // When the theme does not answer, the form still holds the old variant. Then
  // the size button is put back to what the form holds, so the page never
  // shows one size and adds another. done(true) only when the form has it.
  var selectRun = 0;
  function selectVerified(size, done) {
    var run = selectRun += 1, tries = 0;
    if (!selectSizeOnPdp(size)) { done(false); return; }
    (function wait() {
      if (run !== selectRun) { done(false); return; } // a newer pick, by us or by hand, took over
      if (formHasSize(size)) { done(true); return; }
      tries += 1;
      if (tries < 40) { window.setTimeout(wait, 100); return; }
      var held = PIECE.variantSize[variantId()];
      sizeRadios().forEach(function (r) { if (held && String(r.value || '').trim().toUpperCase() === held) r.checked = true; });
      warn('the theme did not switch to ' + size);
      done(false);
    })();
  }

  /* ---- The saved size on the page: drawer box and a quiet line by the Size guide link ---- */
  function renderEntry() {
    var saved = savedSize();
    all('[data-twrd-size-finder-open][data-twrd-sf-entry]').forEach(function (b) {
      var label = saved ? 'Your size: ' + saved + ' \u00b7 Change' : ENTRY_TEXT;
      if (b.textContent !== label) b.textContent = label;
    });
    var row = document.querySelector('.twrd-quiz-trigger-row');
    var mine = document.querySelector('.twrd-sf-mine');
    if (row) row.classList.toggle('twrd-sf-row', !!saved);
    if (!saved || !row) { if (mine && mine.parentNode) mine.parentNode.removeChild(mine); return; }
    if (!mine || mine.parentNode !== row) {
      if (mine && mine.parentNode) mine.parentNode.removeChild(mine);
      mine = document.createElement('button');
      mine.type = 'button';
      mine.className = 'twrd-sf-mine';
      mine.setAttribute('data-twrd-size-finder-open', '');
      mine.setAttribute('aria-haspopup', 'dialog');
      row.appendChild(mine);
    }
    var text = 'Your size: ' + saved + (PIECE.avail[saved] ? '' : ' (sold out)');
    if (mine.textContent !== text) mine.textContent = text;
  }

  /* ================= Pop-up render ================= */
  function buildRuler(k) {
    var c = RULER[pop.unit][k], svg = $('ruler-' + k).querySelector('svg'), out = '';
    for (var v = c.min; v <= c.max; v += 1) {
      var x = (v - c.min) * c.ppu, lvl = v % c.major === 0 ? 'max' : (v % c.mid === 0 ? 'mid' : 'min'), h = lvl === 'max' ? 24 : (lvl === 'mid' ? 17 : 9);
      out += '<line class="twrd-sf__t--' + lvl + '" x1="' + x + '" y1="0" x2="' + x + '" y2="' + h + '"/>';
      if (v % c.label === 0) out += '<text x="' + x + '" y="46">' + (k === 'h' && pop.unit === 'us' ? fmtH('us', v).short : v) + '</text>';
    }
    svg.setAttribute('width', (c.max - c.min) * c.ppu); svg.setAttribute('height', 64);
    svg.innerHTML = out;
  }
  function buildInputs() {
    $('val-h').innerHTML = pop.unit === 'us'
      ? '<input class="twrd-sf__num twrd-sf__num--1" id="twrd-sf-in-ft" inputmode="numeric" maxlength="1" autocomplete="off" aria-label="Feet"><span class="twrd-sf__sym">\'</span>' +
        '<input class="twrd-sf__num twrd-sf__num--2" id="twrd-sf-in-in" inputmode="numeric" maxlength="2" autocomplete="off" aria-label="Inches"><span class="twrd-sf__u">ft in</span>'
      : '<input class="twrd-sf__num" id="twrd-sf-in-cm" inputmode="numeric" maxlength="3" autocomplete="off" aria-label="Height in centimeters"><span class="twrd-sf__u">cm</span>';
    $('val-w').innerHTML = '<input class="twrd-sf__num" id="twrd-sf-in-w" inputmode="numeric" maxlength="3" autocomplete="off" aria-label="Weight in ' +
      (pop.unit === 'us' ? 'pounds' : 'kilograms') + '"><span class="twrd-sf__u">' + (pop.unit === 'us' ? 'lb' : 'kg') + '</span>';
  }
  function putValue(id, v) { var el = $(id); if (el && document.activeElement !== el) el.value = String(v); }
  function renderRuler(k) {
    var c = RULER[pop.unit][k], el = $('ruler-' + k), f = k === 'h' ? fmtH(pop.unit, pop.h) : fmtW(pop.unit, pop.w);
    el.querySelector('svg').style.transform = 'translateX(' + (-(pop[k] - c.min) * c.ppu) + 'px)';
    el.setAttribute('aria-valuemin', c.min); el.setAttribute('aria-valuemax', c.max);
    el.setAttribute('aria-valuenow', pop[k]); el.setAttribute('aria-valuetext', f.say);
  }
  function answers() {
    // Indexed by data-q. The recap shows only the questions this piece asks.
    return [fmtH(pop.unit, pop.h).short, fmtW(pop.unit, pop.w).short, BUILD_WORD[pop.build] || '', FIT_WORD[pop.fit] || ''];
  }

  function renderPop() {
    if (builtUnit !== pop.unit) { buildRuler('h'); buildRuler('w'); buildInputs(); builtUnit = pop.unit; }
    all('#twrd-sf-unit button').forEach(function (b) { b.setAttribute('aria-pressed', String(b.getAttribute('data-v') === pop.unit)); });
    if (pop.unit === 'us') { putValue('in-ft', Math.floor(pop.h / 12)); putValue('in-in', pop.h % 12); } else putValue('in-cm', pop.h);
    putValue('in-w', pop.w);
    renderRuler('h'); renderRuler('w');

    var ans = answers(), done = pop.reached >= N;
    $('prog').textContent = (pop.active !== null ? pop.active + 1 : N) + ' / ' + N;
    // Progress bar under the header: one segment per question, answered ones filled.
    var bar = $('bar');
    if (bar) {
      if (bar.children.length !== N) { bar.innerHTML = ''; for (var bi = 0; bi < N; bi += 1) bar.appendChild(document.createElement('i')); }
      for (var bj = 0; bj < N; bj += 1) bar.children[bj].className = bj < (done ? N : pop.reached) ? 'is-done' : '';
    }
    $('recap').hidden = !pop.compact;
    $('recap-text').textContent = ORDER.map(function (i) { return ans[i]; }).join(' \u00b7 ');
    $('talk').hidden = pop.compact;
    all('.twrd-sf__q', root).forEach(function (li) {
      var i = Number(li.getAttribute('data-q')), pos = ORDER.indexOf(i), open = pos >= 0 && pop.active === pos, answered = pos >= 0 && pos < pop.reached;
      li.hidden = !open && !answered;
      li.querySelector('.twrd-sf__sum').hidden = open;
      li.querySelector('.twrd-sf__open').hidden = !open;
      li.querySelector('.twrd-sf__ans').textContent = ans[i];
      li.querySelector('.twrd-sf__sum').setAttribute('aria-label', li.querySelector('.twrd-sf__label').textContent + ': ' + ans[i] + '. Change');
      li.querySelector('[data-back]').hidden = pos <= 0;
      var next = li.querySelector('[data-next]');
      next.textContent = done ? 'Done' : (i === 3 ? 'See my size' : 'Continue');
      next.disabled = (i === 2 && !pop.build) || (i === 3 && !pop.fit);
    });
    all('[data-pick] .twrd-sf__tile', root).forEach(function (b) {
      b.setAttribute('aria-pressed', String(pop[b.parentNode.getAttribute('data-pick')] === b.getAttribute('data-v')));
    });
    $('res').hidden = !done;
    if (done) renderResult();
  }

  function renderResult() {
    var v = view(), u = pop.unit, cols = PIECE.cols, hasChart = cols.length === 2;
    $('letter').textContent = v.letter;
    $('sentence').textContent = v.sentence;
    if ($('ref')) { $('ref').textContent = PIECE.model; $('ref').hidden = !PIECE.model; }
    $('alt').textContent = v.altText;
    $('row').innerHTML = PIECE.sizes.map(function (s) {
      var cls = s === v.pick ? 'is-pick' : (s === v.alt ? 'is-alt' : ''), out = !PIECE.avail[s];
      return '<li class="' + cls + (out ? ' is-out' : '') + '">' + s + '<span class="twrd-sf__sr">' +
        (cls === 'is-pick' ? ', your size' : (cls ? ', alternative' : '')) + (out ? ', sold out' : '') + '</span></li>';
    }).join('');
    var m = v.pick && hasChart ? PIECE.rows[v.pick] : null;
    $('flat').hidden = !m;
    if (m && cols[0].toLowerCase() === 'waist') $('flat').textContent = 'Size ' + v.pick + ': waist ' + len(u, m[0]) + ' ' + lenU(u) + ' around, ' +
      cols[1].toLowerCase() + ' ' + len(u, m[1]) + ' ' + lenU(u) + ' laid flat.';
    else if (m) $('flat').textContent = 'Size ' + v.pick + ', laid flat: ' + cols[0].toLowerCase() + ' ' + len(u, m[0]) + ' ' + lenU(u) + ', ' +
      cols[1].toLowerCase() + ' ' + len(u, m[1]) + ' ' + lenU(u) + '.';
    $('add').hidden = !v.pick || PIECE.upcoming; $('save').hidden = !v.pick;
    if (v.pick) {
      $('add').textContent = v.out ? v.pick + ' is sold out' : 'Add ' + v.pick + ' to bag';
      $('add').disabled = v.out || adding;
    }
    $('saved').textContent = pop.savedMsg;
    $('saved').hidden = !pop.savedMsg;

    // Own-piece comparison. Only when there is a chart to compare with.
    var open = pop.cmpOpen && hasChart;
    $('cmp-open').hidden = !hasChart;
    $('cmp-q').textContent = 'Know your size in ' + PIECE.own + '?';
    $('cmp-open').setAttribute('aria-expanded', String(open));
    $('cmp').hidden = !open;
    if (!open) return;
    var waist = cols[0].toLowerCase() === 'waist';
    $('cmp-la').textContent = cols[0] + (waist ? '' : ' width');
    $('cmp-lb').textContent = cols[1];
    all('.twrd-sf__cmp-u', root).forEach(function (s) { s.textContent = lenU(u); });
    putValue('cmp-a', pop.cmpA); putValue('cmp-b', pop.cmpB);
    $('cmp-how').textContent = waist
      ? 'Waist and hip: measure all the way around. Outseam and leg opening: lay the pair flat.'
      : 'Lay it flat. Chest: armpit to armpit. Length: top of the shoulder to the hem.';
    var k = u === 'metric' ? 1 : IN, a = parseNum(pop.cmpA) * k, b = parseNum(pop.cmpB) * k;
    var cmp = compareOwn(a, b), msg = '', use = '';
    if (!cmp) {
      if (pop.cmpA !== '' && pop.cmpB !== '') msg = 'Check the numbers. Measure flat, edge to edge.';
    } else if (pop.override && pop.override === cmp.best && cmp.best !== v.bodyPick) {
      msg = 'You took ' + cmp.best + ' from your own ' + PIECE.noun + '.' + (v.bodyPick ? ' Your body reads ' + v.bodyPick + '.' : '');
      use = v.bodyPick ? 'Back to ' + v.bodyPick : '';
    } else if (!v.bodyPick) {
      msg = 'Your own ' + PIECE.noun + ' measures like ' + cmp.best + '. Take ' + cmp.best + '.';
      use = 'Use ' + cmp.best;
    } else if (cmp.best === v.bodyPick) {
      msg = 'Your own ' + PIECE.noun + ' measures like ' + cmp.best + '. That matches your size.';
    } else {
      msg = 'Your own ' + PIECE.noun + ' measures like ' + cmp.best + '. Your body reads ' + v.bodyPick + '. If you like how that ' + PIECE.noun + ' sits, take ' + cmp.best + '.';
      use = 'Switch to ' + cmp.best;
    }
    $('cmp-msg').textContent = msg; $('cmp-msg').hidden = !msg;
    $('cmp-use').textContent = use; $('cmp-use').hidden = !use;
    $('cmp-use').setAttribute('data-size', cmp ? cmp.best : '');
    $('cmp-table').hidden = !cmp;
    if (cmp) {
      $('cmp-head').innerHTML = '<th scope="col">Size</th><th scope="col"></th><th scope="col"></th>';
      var heads = $('cmp-head').children;
      heads[1].textContent = cols[0]; heads[2].textContent = cols[1];
      $('cmp-rows').innerHTML = cmp.rows.map(function (r) {
        return '<tr class="' + (r.size === cmp.best ? 'is-best' : '') + '"><th scope="row">' + r.size + (r.size === cmp.best ? '<span class="twrd-sf__sr">, best match</span>' : '') + '</th>' +
          [0, 1].map(function (i) { return '<td>' + len(u, r.m[i]) + ' ' + lenU(u) + '<small>' + signed(u, r.d[i]) + '</small></td>'; }).join('') + '</tr>';
      }).join('');
    }
  }

  /* ================= Actions ================= */
  function switchUnit(unit) {
    if (unit === pop.unit) return;
    var r = RULER[unit], toM = unit === 'metric';
    var conv = function (t) { var n = parseNum(t); return isNaN(n) ? '' : String(Math.round((toM ? n * IN : n / IN) * 10) / 10); };
    setPop({ unit: unit, override: pop.override, cmpA: conv(pop.cmpA), cmpB: conv(pop.cmpB),
      h: clamp(Math.round(toM ? pop.h * IN : pop.h / IN), r.h.min, r.h.max),
      w: clamp(Math.round(toM ? pop.w * LB : pop.w / LB), r.w.min, r.w.max) });
    $('cmp-a').value = pop.cmpA; $('cmp-b').value = pop.cmpB;
  }
  function setValue(k, v) { var c = RULER[pop.unit][k]; var patch = {}; patch[k] = clamp(Math.round(v), c.min, c.max); setPop(patch); }
  // pos is the place in ORDER. The list item carries the data-q index.
  function focusQ(pos) {
    var i = ORDER[pos], li = root.querySelector('.twrd-sf__q[data-q="' + i + '"]');
    var t = i < 2 ? li.querySelector('.twrd-sf__ruler') : (li.querySelector('.twrd-sf__tile[aria-pressed="true"]') || li.querySelector('.twrd-sf__tile'));
    if (t) t.focus({ preventScroll: true });
    li.scrollIntoView({ block: 'nearest' });
  }
  function showResult() {
    var body = $('body'), res = $('res');
    body.scrollTop = Math.max(0, res.offsetTop - 8);
    res.focus({ preventScroll: true });
  }
  function openQ(i) { setPop({ active: i, compact: false }); focusQ(i); }
  function next() {
    var pos = pop.active, i = ORDER[pos];
    if (pos === null || (i === 2 && !pop.build) || (i === 3 && !pop.fit)) return;
    commitInputs();
    var reached = Math.max(pop.reached, pos + 1);
    setPop({ reached: reached, active: reached < N ? reached : null });
    if (pop.active === null) showResult(); else focusQ(pop.active);
  }
  function back() { if (pop.active > 0) openQ(pop.active - 1); }
  function commitInputs() {
    // Clamp whatever is typed, then let render rewrite the fields.
    var a = document.activeElement;
    if (a && a.classList && a.classList.contains('twrd-sf__num')) a.blur();
  }
  function readTyped(commit) {
    var c = RULER[pop.unit], h, w = parseNum($('in-w').value);
    if (pop.unit === 'us') { var ft = parseNum($('in-ft').value), inch = parseNum($('in-in').value); h = ft * 12 + (isNaN(inch) ? 0 : inch); }
    else h = parseNum($('in-cm').value);
    var patch = {};
    if (!isNaN(h) && (commit || (h >= c.h.min && h <= c.h.max))) patch.h = clamp(Math.round(h), c.h.min, c.h.max);
    if (!isNaN(w) && (commit || (w >= c.w.min && w <= c.w.max))) patch.w = clamp(Math.round(w), c.w.min, c.w.max);
    setPop(patch);
  }

  function buildProfile(pick) {
    var m = metric(pop), old = page.profile;
    var cm = Math.round(m.cm * 10) / 10, kg = Math.round(m.kg * 10) / 10;
    // Sizes saved for other kinds of piece stay only while the answers are the same.
    // Sweatpants do not ask for build. A build saved earlier on a tee is kept.
    var build = PANTS ? (old && old.heightCm === cm && old.weightKg === kg ? old.build : null) : pop.build;
    var same = old && old.heightCm === cm && old.weightKg === kg && old.build === build && old.fit === pop.fit;
    var sizes = Object.assign({}, same ? old.sizes : {});
    sizes[PIECE.kind] = pick;
    return { v: 1, heightCm: cm, weightKg: kg, build: build, fit: pop.fit, unit: pop.unit, sizes: sizes, savedAt: new Date().toISOString() };
  }
  function save() {
    var v = view(); if (!v.pick) return;
    var profile = buildProfile(v.pick);
    var ok = writeProfile(profile);
    if (ok) {
      page = Object.freeze({ profile: profile });
      try { persistRemote(profile); } catch (err) { warn('remote save failed', err); }
      if (!v.out) selectVerified(v.pick, function () {});
    }
    renderEntry();
    setPop({ savedMsg: ok ? 'Saved on this device.' : 'Could not save on this device. Your size still works for this visit.' });
  }
  // Select the size with the theme's picker, then click the theme's own add
  // button. Nothing is added when the form does not hold the wanted size.
  function addToBag() {
    var v = view(); if (!v.pick || v.out || adding || PIECE.upcoming) return;
    adding = true; renderPop();
    selectVerified(v.pick, function (ok) {
      // The theme swaps parts of the product form after a variant change, and
      // its product-form element binds the submit handler one tick after it
      // connects. A click inside that gap would post the form natively and
      // leave the page. So let the form settle, then check it once more.
      window.setTimeout(function () {
        adding = false;
        if (!isOpen) return;
        if (!ok || !formHasSize(v.pick)) { setPop({ savedMsg: 'Could not select ' + v.pick + ' here. Close this and pick ' + v.pick + ' on the page.' }); return; }
        var main = primaryAddButton(), form = main ? main.closest('form') : productForm();
        if (main && main.disabled) { setPop({ savedMsg: v.pick + ' is sold out in this style.' }); return; }
        closePop();
        // Hand the theme a submit event first. Its product-form handler takes
        // it (preventDefault) and adds through the cart store, so the cart
        // drawer opens. A scripted submit event can never post the form
        // natively. Only when nothing took it do we click the add button.
        var taken = form ? !form.dispatchEvent(new Event('submit', { bubbles: true, cancelable: true })) : false;
        if (taken) return;
        if (main) main.click();
        else if (typeof form.requestSubmit === 'function') form.requestSubmit();
        else form.submit();
      }, ok ? 400 : 0);
    });
  }

  /* ================= Open / close ================= */
  function fromProfile(p) {
    var unit = p.unit === 'metric' || p.unit === 'us' ? p.unit : FRESH.unit, r = RULER[unit];
    // A profile made on sweatpants has no build. On a tee or hoodie the
    // visitor then lands on the build question, with the rest kept.
    var gap = !PANTS && !p.build, at = ORDER.indexOf(2);
    return Object.assign({}, FRESH, { unit: unit, build: p.build, fit: p.fit, active: gap ? at : null, reached: gap ? at : N, compact: !gap,
      h: clamp(Math.round(unit === 'metric' ? p.heightCm : p.heightCm / IN), r.h.min, r.h.max),
      w: clamp(Math.round(unit === 'metric' ? p.weightKg : p.weightKg / LB), r.w.min, r.w.max) });
  }
  function openPop(trigger) {
    if (isOpen) return;
    pop = Object.freeze(Object.assign({}, page.profile ? fromProfile(page.profile) : FRESH));
    if (page.profile) {
      // A saved size that differs from the body reading came from the own-piece comparison.
      var own = soldSize(page.profile.sizes[PIECE.kind]), r = recNow();
      if (own && (r.state !== 'ok' || r.pick !== own)) pop = Object.freeze(Object.assign({}, pop, { override: own }));
    }
    // Opened from inside the drawer: the drawer has closed and given focus
    // back to the link that opened it. That link is where focus returns.
    returnTo = trigger && !trigger.closest('[data-twrd-size-guide]') ? trigger : (document.querySelector('.twrd-quiz-trigger') || document.activeElement);
    isOpen = true; adding = false;
    root.hidden = false;
    prevOverflow = document.body.style.overflow;
    document.body.style.overflow = 'hidden';
    document.documentElement.classList.add('twrd-sf-open');
    document.addEventListener('keydown', onKeydown, true);
    $('cmp-a').value = pop.cmpA; $('cmp-b').value = pop.cmpB;
    renderPop();
    $('body').scrollTop = 0;
    if (pop.active !== null) focusQ(pop.active); else $('box').focus();
  }
  function closePop() {
    if (!isOpen) return;
    isOpen = false;
    root.hidden = true;
    document.body.style.overflow = prevOverflow === 'hidden' ? '' : prevOverflow;
    document.documentElement.classList.remove('twrd-sf-open');
    document.removeEventListener('keydown', onKeydown, true);
    if (returnTo && document.contains(returnTo) && typeof returnTo.focus === 'function') returnTo.focus();
    returnTo = null;
  }
  function focusables() {
    return all('button:not([disabled]), input, [tabindex="0"]', $('box')).filter(function (el) { return el.offsetParent !== null; });
  }
  function onKeydown(e) {
    if (e.key === 'Escape' || e.key === 'Esc') { e.preventDefault(); e.stopPropagation(); closePop(); return; }
    if (e.key === 'Tab') {
      var f = focusables(); if (!f.length) return;
      var first = f[0], last = f[f.length - 1], a = document.activeElement, inside = $('box').contains(a);
      if (e.shiftKey && (a === first || a === $('box') || a === $('res') || !inside)) { e.preventDefault(); last.focus(); }
      else if (!e.shiftKey && (a === last || !inside)) { e.preventDefault(); first.focus(); }
      return;
    }
    var t = e.target;
    if (e.key === 'Enter' && t.closest && t.closest('.twrd-sf__open') && (t.classList.contains('twrd-sf__num') || t.classList.contains('twrd-sf__ruler'))) {
      e.preventDefault();
      if (t.classList.contains('twrd-sf__num')) readTyped(true);
      next();
    }
  }

  /* ================= Events ================= */
  // The drawer's own handler runs first (it sits on the drawer root) and closes
  // the drawer. This one then opens the pop-up in its place.
  document.addEventListener('click', function (e) {
    var trigger = e.target.closest && e.target.closest('[data-twrd-size-finder-open]');
    if (!trigger) return;
    e.preventDefault();
    openPop(trigger);
  });
  root.addEventListener('click', function (e) {
    if (e.target.closest('[data-twrd-sf-close]')) { e.preventDefault(); closePop(); }
  });
  $('table').addEventListener('click', function () {
    closePop();
    document.dispatchEvent(new CustomEvent('twrd:size-guide:open'));
  });

  $('talk').addEventListener('click', function (e) {
    var t = e.target;
    var sum = t.closest('.twrd-sf__sum'); if (sum) { openQ(ORDER.indexOf(Number(sum.parentNode.getAttribute('data-q')))); return; }
    if (t.closest('[data-next]')) { next(); return; }
    if (t.closest('[data-back]')) { back(); return; }
    var u = t.closest('#twrd-sf-unit button'); if (u) { switchUnit(u.getAttribute('data-v')); return; }
    var st = t.closest('.twrd-sf__step'); if (st) { setValue(st.getAttribute('data-k'), pop[st.getAttribute('data-k')] + Number(st.getAttribute('data-step'))); return; }
    var tile = t.closest('.twrd-sf__tile');
    if (tile) {
      var patch = {}; patch[tile.parentNode.getAttribute('data-pick')] = tile.getAttribute('data-v');
      setPop(patch);
      next(); // A tile answers the question. Continue stays for keyboard use.
    }
  });
  function isNum(el) { return el.classList && el.classList.contains('twrd-sf__num'); }
  $('talk').addEventListener('input', function (e) { if (isNum(e.target)) readTyped(false); });
  $('talk').addEventListener('change', function (e) { if (isNum(e.target)) { readTyped(true); renderPop(); } });
  $('talk').addEventListener('focusout', function (e) { if (isNum(e.target)) window.setTimeout(renderPop, 0); });
  $('talk').addEventListener('focusin', function (e) { if (isNum(e.target)) e.target.select(); });

  all('.twrd-sf__ruler', root).forEach(function (el) {
    var k = el.getAttribute('data-k');
    el.addEventListener('pointerdown', function (e) {
      if (e.pointerType === 'mouse' && e.button !== 0) return;
      dragging = { k: k, x: e.clientX, v: pop[k], ppu: RULER[pop.unit][k].ppu };
      el.classList.add('is-drag');
      try { el.setPointerCapture(e.pointerId); } catch (err) { /* capture is optional */ }
    });
    el.addEventListener('pointermove', function (e) {
      if (!dragging || dragging.k !== k) return;
      // Drag left: the scale moves left, so a higher value comes under the marker.
      setValue(k, dragging.v - (e.clientX - dragging.x) / dragging.ppu);
    });
    function end() { dragging = null; el.classList.remove('is-drag'); }
    el.addEventListener('pointerup', end);
    el.addEventListener('pointercancel', end);
    el.addEventListener('keydown', function (e) {
      var c = RULER[pop.unit][k], v = pop[k];
      if (e.key === 'ArrowRight' || e.key === 'ArrowUp') v += 1;
      else if (e.key === 'ArrowLeft' || e.key === 'ArrowDown') v -= 1;
      else if (e.key === 'PageUp') v += c.major;
      else if (e.key === 'PageDown') v -= c.major;
      else if (e.key === 'Home') v = c.min;
      else if (e.key === 'End') v = c.max;
      else return;
      e.preventDefault();
      setValue(k, v);
    });
  });

  $('recap-btn').addEventListener('click', function () { openQ(0); });
  $('add').addEventListener('click', addToBag);
  $('save').addEventListener('click', save);
  $('cmp-open').addEventListener('click', function () {
    setPop({ cmpOpen: !pop.cmpOpen });
    if (pop.cmpOpen) { $('cmp-a').focus({ preventScroll: true }); $('cmp').scrollIntoView({ block: 'nearest' }); }
  });
  ['cmp-a', 'cmp-b'].forEach(function (id) {
    $(id).addEventListener('input', function (e) {
      var patch = { override: null, savedMsg: '' }; patch[id === 'cmp-a' ? 'cmpA' : 'cmpB'] = e.target.value.trim();
      setPop(patch);
    });
  });
  $('cmp-use').addEventListener('click', function () {
    var size = $('cmp-use').getAttribute('data-size');
    setPop({ override: pop.override === size ? null : size, savedMsg: '' });
    showResult();
  });

  /* ================= Init ================= */
  if (PANTS) $('ed').textContent = 'Three quick questions. One size.';
  all('[data-build]', root).forEach(function (svg) {
    var fig = BUILD_FIG[svg.getAttribute('data-build')];
    if (fig) svg.innerHTML = buildFigure(fig);
  });

  // A size picked by hand on this page is never overridden.
  var handPicked = false;
  document.addEventListener('change', function (e) {
    var t = e.target;
    if (!selfPick && t && (t.type === 'radio' || t.tagName === 'SELECT') && isSizeName(t.name)) { handPicked = true; selectRun += 1; }
  }, true);

  // Preselect the saved size once, when it is sold here and in stock. A link
  // that names a variant (?variant=) is a choice too, so it is left alone.
  function preselect() {
    if (handPicked || /[?&]variant=/.test(window.location.search)) return;
    var saved = savedSize();
    if (saved && PIECE.avail[saved] && !formHasSize(saved)) selectVerified(saved, function () {});
  }

  // The theme's picker is a custom element. A click that lands before the
  // element is defined checks the radio, but the theme never hears it, and the
  // element then starts up with the wrong variant cached. So wait for it.
  function whenPickerReady(fn) {
    var radio = sizeRadios()[0];
    var host = radio && radio.closest ? radio.closest('variant-radios, variant-selects, variant-mixed-inputs') : null;
    if (!host || !window.customElements || typeof window.customElements.whenDefined !== 'function') return;
    window.customElements.whenDefined(host.tagName.toLowerCase()).then(function () { window.setTimeout(fn, 60); });
  }

  function ready(fn) {
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', fn); else fn();
  }
  ready(function () {
    renderEntry();
    whenPickerReady(preselect);
    // The theme re-renders the product form on a variant change, and the Size
    // guide link is injected late. Put the saved-size line back when it is gone.
    var scope = document.querySelector('.product-single') || document.body, queued = false;
    new MutationObserver(function () {
      if (queued) return;
      queued = true;
      window.setTimeout(function () { queued = false; renderEntry(); }, 120);
    }).observe(scope, { childList: true, subtree: true });
  });

  // Another tab saved or cleared the size.
  window.addEventListener('storage', function (e) {
    if (e.key !== KEY) return;
    page = Object.freeze({ profile: readProfile() });
    renderEntry();
  });

  // For console checks and tests. Pure functions only.
  window.__twrdSizeFinder = Object.freeze({ recommend: recommend, compareOwn: compareOwn, rule: RULE });
})();
